

















import Vue from 'vue'
import ItemsParser from '@/components/parsers/ItemsParser.vue'
// eslint-disable-next-line
let lastParsedGroup = {} as Record<string, any>
// eslint-disable-next-line
let lastParsedItem = {} as Record<string, any>
let firstItemKeyAfterHeaderGreenFound = false

export default Vue.extend({
  name: 'Groups',

  components: { ItemsParser },

  data: () => ({
    groupedTop: -1
  }),

  computed: {
    isDataUndefined (): boolean {
      return typeof this.$props.mainData === 'undefined'
    }
  },

  props: {
    mainData: {
      required: true
    }
  },

  methods: {
    // Method returns key inside group of first item that doesn't have headerGreen style theme, empty string otherwise
    // eslint-disable-next-line
    getFirstItemKeyAfterHeaderTheme (parsingGroup: Record<string, any>): string {
      if (firstItemKeyAfterHeaderGreenFound) {
        return ''
      }
      for (const key in parsingGroup.items) {
        if (Object.prototype.hasOwnProperty.call(parsingGroup.items[key], 'style')) {
          const style = parsingGroup.items[key].style
          if (style.theme !== 'headerGreen') {
            /*
            if item that has no headerGreen theme is first item in present group,
            check that last item in group before has headerGreen theme
             */
            if (parseInt(key) === 0) {
              if (Object.prototype.hasOwnProperty.call(lastParsedGroup, 'items')) {
                const prevItem = lastParsedGroup.items[lastParsedGroup.items.length - 1]
                if (this.isItemStyleHeaderGreen(prevItem)) {
                  this.setFirstItemKeyAfterHeaderFound()
                  return key
                }
              }
            } else {
              /*
              if item that has no headerGreen theme isn't first item in present group,
              check that item before has headerGreen theme
               */
              if (this.isItemStyleHeaderGreen(lastParsedItem)) {
                this.setFirstItemKeyAfterHeaderFound()
                return key
              }
            }
          }
        }
        lastParsedItem = parsingGroup.items[key]
      }
      lastParsedGroup = parsingGroup

      return ''
    },
    // eslint-disable-next-line
    isItemStyleHeaderGreen (item: Record<string, any> | undefined): boolean {
      return typeof item !== 'undefined' &&
        Object.prototype.hasOwnProperty.call(item, 'style') &&
        item.style.theme === 'headerGreen'
    },
    setFirstItemKeyAfterHeaderFound (): void {
      // when key found set this variable to stop processing other groups
      firstItemKeyAfterHeaderGreenFound = true
      // reset variables so items after can be processed properly
      lastParsedItem = {}
      lastParsedGroup = {}
    },
    // eslint-disable-next-line
    isGroupedTop (parsingGroup: Record<string, any>, idx: number): number | null {
      for (const key in parsingGroup.items) {
        if (Object.prototype.hasOwnProperty.call(parsingGroup.items[key], 'style')) {
          const style = parsingGroup.items[key].style
          if (style.theme && style.theme === 'groupedTop') {
            this.groupedTop = idx
            return idx
          }
        }
      }
      return this.groupedTop
    }
  }
})
